import React from "react";
import { toCamelCase } from "./helpers";

const PhotographerFilters = ({ filters, services, isLock, onFilterChange, onReset, roleKey }) => {
    return (
    <div className="filter-container">

        {/* Rating */}
        <div className="filter-item">
            <label>Rating</label>
            <select
                className="float-filter-select"
                value={filters.rating}
                onChange={(e) => onFilterChange("rating", e.target.value)}
                disabled={isLock}
            >
                <option value="">All</option>
                {[5, 4, 3, 2, 1].map((r) => (
                    <option key={r} value={String(r)}>
                        {r} star{r !== 1 ? "s" : ""}
                    </option>
                ))}
            </select>
        </div>

        {/* Category */}
        <div className="filter-item">
            <label>Category</label>
            <select
                className="float-filter-select"
                value={filters.category}
                onChange={(e) => onFilterChange("category", e.target.value)}
                disabled={isLock}
            >
                <option value="">All</option>
                {services.map((service) => (
                    <option
                        key={service._id}
                        value={toCamelCase(service.serviceName || service.key)}
                    >
                        {service.serviceName}
                    </option>
                ))}
            </select>
        </div>

        {/* Expertise */}
        <div className="filter-item">
            <label>Expertise</label>
            <select
                className="float-filter-select"
                value={filters.expertise}
                onChange={(e) => onFilterChange("expertise", e.target.value)}
                disabled={isLock}
            >
                <option value="">All</option>
                {roleKey === "editor" ? (
                    <>
                        <option value="standard">STANDARD</option>
                        <option value="premium">PREMIUM</option>
                    </>
                ) : (
                    <>
                        <option value="initio">INITIO</option>
                        <option value="elite">ELITE</option>
                        <option value="pro">PRO</option>
                    </>
                )}
            </select>
        </div>

        <div className="filter-actions">
            <button
                type="button"
                className="btn-reset"
                onClick={onReset}
                disabled={isLock}
            >
                Reset All
            </button>
        </div>
    </div>
    );
};

export default PhotographerFilters;
